import { Ref } from 'vue'
import { useBusinessMutation, useBusinessQuery } from './fetchBusinessData'

interface IAxiosRequest<T> {
  data: Ref<T>
  error: Ref<Error | null>
}

export function handleResponse<T>(
  response: ReturnType<typeof useBusinessQuery<T>> | ReturnType<typeof useBusinessMutation<T>>,
) {
  if (response.error.value) throw response.error.value
  else if (!response.data.value) throw new Error('Error communicating with the server')
  else {
    const data = response.data.value as T
    return data
  }
}

export function handleAxiosResponse<T>(response: IAxiosRequest<T>) {
  if (response.error.value) throw response.error.value
  else if (!response.data.value) throw new Error('Error communicating with the server')
  else {
    return response.data.value
  }
}
